import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export type Mode = "dark" | "light"

type StateGlobal = {
  mode: Mode
}

const initialState: StateGlobal = {
  mode: "light",
}

const globalSlice = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    setMode: (state, action: PayloadAction<Mode>) => {
      state.mode = action.payload
    },
  },
})

export const { setMode } = globalSlice.actions

export default globalSlice.reducer
